import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// Components
import DeclinedServicesList from './DeclinedServicesList';

// Actions
import {
  addDeclinedService,
  removeDeclinedService,
  clearDeclinedServices,
  addService,
  removeService
} from 'store/reducers/appointment/actions';
import { gtmUserEvent } from 'store/reducers/gtm/actions';
import { updateReadOnlyServices } from 'store/reducers/service/actions';

// Selectors
import {
  getDeclinedServices as getApptDeclinedServices,
  getServices,
  getSelectedDeclinedServicesIds,
  getSelectedDeferredServicesIds
} from 'store/reducers/appointment/selectors';
import {
  getDeclinedServicesPromotion as getDeclinedServices,
  getDeclinedServicesIds
} from 'store/reducers/declined/selectors';
import {
  getDeferredServices,
  getDeferredServicesIds
} from 'store/reducers/deferred/selectors';
import { currentPath } from 'store/reducers/navigation/selectors';

const mapStateToProps = state => ({
  apptDeclinedServices: getApptDeclinedServices(state),
  apptServices: getServices(state),
  declinedServices: getDeclinedServices(state),
  declinedServicesIds: getDeclinedServicesIds(state),
  deferredServices: getDeferredServices(state),
  deferredServicesIds: getDeferredServicesIds(state),
  selectedDeclinedServicesIds: getSelectedDeclinedServicesIds(state),
  selectedDeferredServicesIds: getSelectedDeferredServicesIds(state),
  currentPath: currentPath(state)
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      addDeclinedService,
      removeDeclinedService,
      clearDeclinedServices,
      addService,
      removeService,
      gtmUserEvent,
      updateReadOnlyServices
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeclinedServicesList);



// WEBPACK FOOTER //
// ./src/components/molecules/DeclinedServicesList/DeclinedServicesListContainer.js